/**
 * Ultra-Minimal Button Component
 * Flat colors, no shadow, thin borders
 */

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'error' | 'destructive';
  disabled?: boolean;
  className?: string;
}

export function Button({ 
  children, 
  onClick, 
  type = 'button',
  variant = 'primary',
  disabled = false,
  className = ''
}: ButtonProps) {
  const variantClasses = {
    primary: 'bg-[#0D9488] text-white border border-[#0D9488] hover:bg-[#0a7d73]',
    secondary: 'bg-white text-[#0D9488] border border-[#0D9488] hover:bg-gray-50',
    outline: 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50',
    ghost: 'bg-transparent text-gray-700 border-none hover:bg-gray-100',
    error: 'bg-red-600 text-white border border-red-600 hover:bg-red-700',
    destructive: 'bg-red-600 text-white border border-red-600 hover:bg-red-700',
  };
  
  const baseClasses = 'px-4 py-2 rounded-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {children}
    </button>
  );
}
